export const COMPANY_NAME = "BINUS University";
export const PROJECT_NAME = "Beelajar";
export const PROJECT_DESC = "Beelajar";

export const APP_BASE_URL = window.location.origin+'/auth/msal'; // https://developer.mozilla.org/en-US/docs/Web/API/Location/origin
// export const APP_BASE_URL = window.location.origin; // https://developer.mozilla.org/en-US/docs/Web/API/Location/origin
